function sanitizeSearchTerm(term) {
    let cleanTerm = term.toLowerCase();
    
    cleanTerm = cleanTerm.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    const synonyms = {
        "bolinha": "bola",
        "ping pong": "tenis de mesa",
        "ping-pong": "tenis de mesa"
    };

    for (let key in synonyms) {
        let regex = new RegExp(`\\b${key}\\b`, 'g');
        cleanTerm = cleanTerm.replace(regex, synonyms[key]);
    }

    const stopWords = [" de ", " da ", " do ", " para ", " com ", " em "];

    stopWords.forEach(word => {
        cleanTerm = cleanTerm.replace(new RegExp(word, 'g'), " ");
    });

    cleanTerm = cleanTerm.replace(/\s+/g, ' ').trim();

    return cleanTerm || term; 
}

/* Detecta termos com "cara" de SKU/código (sem sanitizar acentos, sinônimos
   e stopwords, que fariam sentido só para busca em linguagem natural). */
function isLikelySku(term) {
    const t = String(term || '').trim();
    if (!t) return false;
    // Termo sem espaços com ao menos um separador (ponto ou hífen) e um dígito.
    // Cobre: step-70x30x10, EV.65.002.008.0000, AB.1234, H6677-EUR38.
    if (/^[a-z0-9]+([.-][a-z0-9]+)+$/i.test(t) && /\d/.test(t)) return true;
    // Código numérico longo (6+ dígitos contíguos): 6502008000
    if (/^\d{6,}$/.test(t)) return true;
    return false;
}

/* SKU-FIX v4 (2026-09-11): as versões anteriores (v1 2026-06-25, v2
   2026-07-01, v3 2026-09-11 mais cedo) envolviam SKU/código em aspas para
   forçar "frase exata", partindo da premissa de que sem aspas o Shopify
   liga OR entre os pedaços do SKU tokenizado pelo ponto, ou lê um hífen
   solto como operador de NEGAÇÃO. Nenhuma das duas premissas se sustentou
   em teste ao vivo (11/09/2026):
     - SKU de ponto sem aspas (ex. "EV.15.152.016.1000") já casa certinho
       com o produto exato — 1 resultado.
     - SKU de hífen sem aspas (ex. "H6677-EUR38", variante de calçado)
       também já casa certinho — 1 resultado. O operador de NEGAÇÃO do
       Shopify só existe quando o "-" é um TERMO separado por espaço
       (confirmado: "bola -inexistente999" exclui, mas "bola-inexistente999"
       colado simplesmente não bate com nada, sem excluir nada).
     - Em AMBOS os casos, colocar o termo entre aspas faz o Shopify voltar
       ZERO resultados para o produto certo — é isso que estava quebrando
       a busca por SKU no header.
   Conclusão: nunca envolver SKU em aspas. Envia o termo cru, sem alterar
   caixa/acentos (sanitizeSearchTerm é só para busca em linguagem natural).
   Centralizado aqui para as três chamadas (predictive search, página de
   resultados e submit do form) nunca mais divergirem entre si. */
function getSearchQueryValue(rawTerm) {
    return isLikelySku(rawTerm) ? rawTerm : sanitizeSearchTerm(rawTerm);
}

/* Constrói URL de resultados usando o mesmo termo do predictive search e
   restringindo os campos pesquisados aos mesmos do predictive search. */
function buildPistaSearchUrl(rawTerm) {
    const qValue = getSearchQueryValue(rawTerm);
    const base = (window.routes && window.routes.search_url) || '/search';
    const params = new URLSearchParams();
    params.set('q', qValue);
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    params.set('options[fields]', 'title,product_type,variants.sku,variants.barcode,vendor,tag');
    return `${base}?${params.toString()}`;
}

/* SEARCH BACKDROP v2 (2026-10-26, by🔥Pista): scrim estilo Centauro.
   O escurecimento é uma box-shadow no próprio header, ligada pela classe
   html.pista-search-active (ver CSS). O mesmo estado atende as duas
   instâncias de initSearch (desktop e mobile): o Map guarda quais painéis
   estão abertos e a função que fecha cada um. */
const pistaOpenSearchPanels = new Map();

function setPistaSearchBackdrop(id, isOpen, closeFn) {
    if (isOpen) {
        pistaOpenSearchPanels.set(id, closeFn);
    } else {
        pistaOpenSearchPanels.delete(id);
    }

    document.documentElement.classList.toggle('pista-search-active', pistaOpenSearchPanels.size > 0);
}

/* A sombra não recebe cliques — sem isto, um clique na área escura
   acionaria o link/produto que está por baixo. Em fase de captura: se a
   busca está aberta e o clique foi fora do header, cancela o clique e só
   fecha o painel (igual ao backdrop da Centauro). */
/* mousedown fora do header com a busca aberta: preventDefault impede que
   o foco saia do campo (o focusout fecharia o painel ANTES do click e o
   link de baixo navegaria). O fechamento acontece no click abaixo. */
document.addEventListener('mousedown', function (e) {
    if (!pistaOpenSearchPanels.size) return;

    const header = document.getElementById('header-custom-pista');
    if (header && header.contains(e.target)) return;

    e.preventDefault();
}, true);

document.addEventListener('click', function (e) {
    if (!pistaOpenSearchPanels.size) return;

    const header = document.getElementById('header-custom-pista');
    if (header && header.contains(e.target)) return;

    e.preventDefault();
    e.stopPropagation();
    Array.from(pistaOpenSearchPanels.values()).forEach(function (close) {
        if (typeof close === 'function') close();
    });
}, true);

/* ===== Helpers da busca preditiva (PREDICTIVE v2, 2026-10-26) ===== */

function pistaEl(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = String(text);
    return node;
}

function pistaReplaceChildren(parent, child) {
    while (parent.firstChild) parent.removeChild(parent.firstChild);
    if (child) parent.appendChild(child);
}

/* Aceita só http(s) e caminhos relativos ao próprio site. Qualquer outro
   esquema (javascript:, data:, vbscript:...) devolve o fallback. */
function pistaSafeUrl(value, fallback) {
    if (fallback === undefined) fallback = '#';
    if (typeof value !== 'string' || value.trim() === '') return fallback;
    try {
        const u = new URL(value.trim(), window.location.origin);
        if (u.protocol !== 'https:' && u.protocol !== 'http:') return fallback;
        return u.origin === window.location.origin ? u.pathname + u.search + u.hash : u.href;
    } catch (e) {
        return fallback;
    }
}

function pistaArrowIcon() {
    const NS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(NS, 'path');
    path.setAttribute('d', 'M6 12H18M18 12L13 7M18 12L13 17');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    return svg;
}

/* "1.234,56" | "1234.56" | "R$ 99,90" → número. NaN se não der. */
function pistaParsePrice(value) {
    const numericStr = String(value).replace(/[^\d.,]/g, '');
    if (!numericStr) return NaN;
    const lastComma = numericStr.lastIndexOf(',');
    const lastPeriod = numericStr.lastIndexOf('.');
    return lastComma > lastPeriod
        ? parseFloat(numericStr.replace(/\./g, '').replace(',', '.'))
        : parseFloat(numericStr.replace(/,/g, ''));
}

function pistaFormatBRL(val) {
    return 'R$ ' + val.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/* Mesma fonte de configuração do card-08 e do quick-add mobile
   (window.pistaCardPricing, em snippets/global-script.liquid). */
function pistaFillPrice(target, rawValue) {
    if (rawValue == null || rawValue === '') return;

    const price = pistaParsePrice(rawValue);
    if (isNaN(price)) return;
    if (price <= 0) return; /* kit/produto sob consulta: sem preço no autocomplete */

    const cfg = window.pistaCardPricing || {};
    const pct = Number(cfg.pixDiscountPercent);
    const pixOn = cfg.pixEnabled !== false && pct > 0 && pct < 100;

    if (!pixOn) {
        target.textContent = pistaFormatBRL(price);
        return;
    }

    target.appendChild(document.createTextNode(pistaFormatBRL(price * (100 - pct) / 100) + ' '));
    const label = pistaEl('span');
    label.appendChild(document.createTextNode('no Pix '));
    const badge = pistaEl('strong', null, `(- ${pct}% OFF)`);
    badge.style.cssText = 'color:#0a7a2a;font-weight:700;';
    label.appendChild(badge);
    target.appendChild(label);
}


function initSearch(inputId, resultsId, trendingId, predictiveId) {
    const input = document.getElementById(inputId);
    const resultsPanel = document.getElementById(resultsId);
    const trendingContent = document.getElementById(trendingId);
    const predictiveContent = document.getElementById(predictiveId);

    if (!input || !resultsPanel || !trendingContent || !predictiveContent) return;

    const rawWords = document.getElementById('header-custom-pista')?.dataset.searchPlaceholders || "";
    const words = rawWords ? rawWords.split(',') : ["Bola", "Halter"];
    let wI = 0;
    let cI = 0;
    let isDel = false;
    let spd = 50;

    function type() {
        const cur = words[wI % words.length].trim();

        if (input.value === "") {
            input.setAttribute('placeholder', "Pesquise: " + cur.substring(0, cI));
        }

        if (isDel) {
            cI--;
            spd = 30;
        } else {
            cI++;
            spd = 80;
        }

        if (!isDel && cI === cur.length) {
            spd = 1500;
            isDel = true;
        } else if (isDel && cI === 0) {
            isDel = false;
            wI++;
            spd = 300;
        }

        setTimeout(type, spd);
    }

    type();

    function openSearchPanel() {
        resultsPanel.style.display = 'block';
        setPistaSearchBackdrop(inputId, true, closeSearchPanel);

        if (input.value.trim() === '') { 
            trendingContent.style.display = 'block'; 
            predictiveContent.style.display = 'none'; 
        } else {
            trendingContent.style.display = 'none'; 
            predictiveContent.style.display = 'block'; 

            if (
                predictiveContent.childElementCount === 0 ||
                predictiveContent.textContent.includes('Carregando')
            ) {
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
    }

    /* SEARCH BACKDROP (2026-10-26, by🔥Pista): fecha o painel e apaga o
       backdrop num ponto só — usado pelo clique fora, Esc e Tab para fora. */
    function closeSearchPanel() {
        resultsPanel.style.display = 'none';
        setPistaSearchBackdrop(inputId, false);
    }

    input.addEventListener('focus', openSearchPanel);
    input.addEventListener('click', openSearchPanel);

    document.addEventListener('click', (e) => {
        if (!input.contains(e.target) && !resultsPanel.contains(e.target)) {
            closeSearchPanel();
        }
    });

    /* Esc fecha painel + backdrop e tira o foco do campo */
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || resultsPanel.style.display !== 'block') return;
        closeSearchPanel();
        if (document.activeElement === input) input.blur();
    });

    /* Tab para fora do form (teclado) fecha. relatedTarget null = clique em
       área não focável → já tratado pelo listener de clique acima. */
    const searchForm = input.closest('form');
    if (searchForm) {
        searchForm.addEventListener('focusout', (e) => {
            if (e.relatedTarget && !searchForm.contains(e.relatedTarget)) {
                closeSearchPanel();
            }
        });
    }

    /* PREDICTIVE v2 (2026-10-26, by🔥Pista) — auditoria SEO/estrutural, etapa 1.
       C01: o resultado era montado como string HTML e aplicado via innerHTML,
            com termo digitado, títulos e URLs da API interpolados sem escape.
            Agora tudo é montado com createElement + textContent, e URLs/imagens
            passam por pistaSafeUrl (só http/https, nunca javascript:/data:).
       C02: cada busca tem um número de sequência e um AbortController. Uma
            resposta só é renderizada se ainda for a última pedida E se o campo
            ainda contiver o mesmo termo. Apagar o campo cancela o que estiver
            em voo e limpa o painel. HTTP não-OK cai no estado de erro.
       C07: o desconto Pix vinha fixo (* 0.95 e "5%"). Agora lê
            window.pistaCardPricing (global-script.liquid), a mesma fonte do
            card-08 e do quick-add mobile. Preço zero não exibe valor. */
    let debounceTimer;
    let requestSeq = 0;
    let inFlight = null;

    function abortInFlight() {
        if (inFlight) {
            inFlight.abort();
            inFlight = null;
        }
    }

    function renderStatus(text, extraStyle) {
        const box = document.createElement('div');
        box.style.cssText = extraStyle || 'text-align:center;padding:20px;color:#999;';
        box.textContent = text;
        pistaReplaceChildren(predictiveContent, box);
    }

    input.addEventListener('input', function () {
        resultsPanel.style.display = 'block';
        setPistaSearchBackdrop(inputId, true, closeSearchPanel);

        clearTimeout(debounceTimer);

        const rawTerm = this.value.trim();

        if (rawTerm === '') {
            requestSeq++;
            abortInFlight();
            pistaReplaceChildren(predictiveContent);
            trendingContent.style.display = 'block';
            predictiveContent.style.display = 'none';
            return;
        }

        trendingContent.style.display = 'none';
        predictiveContent.style.display = 'block';

        if (predictiveContent.childElementCount === 0) {
            renderStatus('Carregando...');
        }

        debounceTimer = setTimeout(() => {
            const seq = ++requestSeq;
            abortInFlight();
            const controller = typeof AbortController === 'function' ? new AbortController() : null;
            inFlight = controller;

            const processedTerm = getSearchQueryValue(rawTerm);
            const suggestUrl = `${window.routes.search_url}/suggest.json?q=${encodeURIComponent(processedTerm)}&resources[type]=product,query,collection&resources[limit]=10&resources[options][prefix]=last&resources[options][fields]=title,product_type,variants.sku,variants.barcode,vendor`;

            const isCurrent = () => seq === requestSeq && input.value.trim() === rawTerm;

            fetch(suggestUrl, controller ? { signal: controller.signal } : undefined)
                .then(res => {
                    if (!res.ok) throw new Error('HTTP ' + res.status);
                    return res.json();
                })
                .then(data => {
                    if (!isCurrent()) return;
                    if (inFlight === controller) inFlight = null;

                    const results = (data && data.resources && data.resources.results) || {};
                    const allProducts = Array.isArray(results.products) ? results.products : [];
                    const products = allProducts.slice(0, 4);
                    const queries = Array.isArray(results.queries) ? results.queries : [];
                    const collections = Array.isArray(results.collections) ? results.collections : [];
                    const searchUrl = buildPistaSearchUrl(rawTerm);

                    const suggestionsList = [];

                    allProducts.forEach(p => {
                        if (typeof p.product_type === 'string' && p.product_type.trim() !== '') {
                            suggestionsList.push({
                                text: p.product_type,
                                url: `${window.routes.search_url}?q=${encodeURIComponent(p.product_type)}&type=product`
                            });
                        }
                    });

                    collections.forEach(c => {
                        let title = typeof c.title === 'string' ? c.title : '';
                        if (title.includes(':')) {
                            title = title.split(':')[1].trim();
                        }
                        if (title) suggestionsList.push({ text: title, url: c.url });
                    });

                    queries.forEach(q => {
                        if (typeof q.text === 'string' && q.text.trim() !== '') {
                            suggestionsList.push({ text: q.text, url: q.url });
                        }
                    });

                    const seenTexts = new Set();
                    const uniqueSuggestions = suggestionsList.filter(s => {
                        const key = s.text.toLowerCase().trim();
                        if (seenTexts.has(key)) return false;
                        seenTexts.add(key);
                        return true;
                    }).slice(0, 8);

                    const wrapper = pistaEl('div', 'pred-new-wrapper');

                    /* Cabeçalho: Pesquisar "termo" → */
                    const header = pistaEl('div', 'pred-new-header');
                    const headerLink = pistaEl('a');
                    headerLink.href = searchUrl;
                    headerLink.appendChild(document.createTextNode(`Pesquisar "${rawTerm}"`));
                    headerLink.appendChild(pistaArrowIcon());
                    header.appendChild(headerLink);
                    wrapper.appendChild(header);

                    const body = pistaEl('div', 'pred-new-body');

                    /* Coluna de sugestões */
                    const sugCol = pistaEl('div', 'pred-new-suggestions');
                    sugCol.appendChild(pistaEl('span', 'pred-new-title', 'Principais sugestões'));

                    if (uniqueSuggestions.length > 0) {
                        const ul = document.createElement('ul');
                        uniqueSuggestions.forEach(s => {
                            const li = document.createElement('li');
                            const a = pistaEl('a', null, s.text);
                            a.href = pistaSafeUrl(s.url);
                            li.appendChild(a);
                            ul.appendChild(li);
                        });
                        sugCol.appendChild(ul);
                    } else {
                        const none = pistaEl('span', null, 'Nenhuma sugestão');
                        none.style.cssText = 'font-size:13px;color:#999;';
                        sugCol.appendChild(none);
                    }
                    body.appendChild(sugCol);

                    /* Coluna de produtos */
                    const prodCol = pistaEl('div', 'pred-new-products');

                    if (products.length > 0) {
                        products.forEach(p => {
                            const title = typeof p.title === 'string' ? p.title : '';
                            const card = pistaEl('a', 'pred-new-card');
                            card.href = pistaSafeUrl(p.url);

                            const imgBox = pistaEl('div', 'pred-new-img');
                            const imgSrc = p.image ? pistaSafeUrl(p.image, null) : null;
                            if (imgSrc) {
                                const img = document.createElement('img');
                                img.src = imgSrc;
                                img.alt = title;
                                img.loading = 'lazy';
                                img.width = 70;
                                img.height = 70;
                                imgBox.appendChild(img);
                            }
                            card.appendChild(imgBox);

                            const info = pistaEl('div', 'pred-new-info');
                            info.appendChild(pistaEl('div', 'pred-new-title-text', title));
                            const priceBox = pistaEl('div', 'pred-new-price-text');
                            pistaFillPrice(priceBox, p.price);
                            info.appendChild(priceBox);
                            card.appendChild(info);

                            prodCol.appendChild(card);
                        });

                        const allBtn = pistaEl('a', 'pred-new-btn', 'Ver todos os resultados');
                        allBtn.href = searchUrl;
                        prodCol.appendChild(allBtn);
                    } else {
                        const none = pistaEl('span', null, 'Nenhum produto encontrado');
                        none.style.cssText = 'font-size:13px;color:#999;padding:10px 0;display:block;';
                        prodCol.appendChild(none);
                    }
                    body.appendChild(prodCol);
                    wrapper.appendChild(body);

                    pistaReplaceChildren(predictiveContent, wrapper);
                })
                .catch(err => {
                    if (err && err.name === 'AbortError') return;
                    if (!isCurrent()) return;
                    if (inFlight === controller) inFlight = null;
                    renderStatus('Não foi possível carregar os resultados.');
                });
        }, 300);
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initSearch('Search-Input-Pista', 'custom-search-results', 'trending-content', 'predictive-content');
    initSearch('Search-Input-Mobile-Pista', 'custom-search-results-mobile', 'trending-content-mobile', 'predictive-content-mobile');

    /* SKU-FIX (2026-06-25) / v3 (2026-09-11): intercepta o submit do form de
       busca para (1) envolver em aspas só o SKU com hífen (frase exata) e
       (2) sanitizar termos normais (lowercase, acentos, sinônimos, stopwords),
       espelhando o comportamento do predictive search via getSearchQueryValue.
       Os hidden inputs options[prefix] e options[fields] já estão no markup. */
    document.querySelectorAll('form[data-pista-search-form]').forEach(form => {
        form.addEventListener('submit', function () {
            const input = form.querySelector('input[name="q"]');
            if (!input) return;
            const raw = input.value.trim();
            if (!raw) return;
            input.value = getSearchQueryValue(raw);
        });
    });
    
    const header = document.getElementById('header-custom-pista');
    const stickyEnabled = document.getElementById('header-custom-pista')?.dataset.sticky === 'true';

    if (header && stickyEnabled) {
        let spacer = document.getElementById('header-spacer-pista');

        if (!spacer) {
            spacer = document.createElement('div');
            spacer.id = 'header-spacer-pista';
            header.parentNode.insertBefore(spacer, header);
        }

        const oldSpacer = document.getElementById('header-spacer');
        const topBar = header.querySelector('.header-top-pista');

        function getTriggerPoint() {
            if (window.innerWidth > 1024 && topBar) {
                return topBar.offsetHeight || 36;
            }

            /* by🔥Pista 2026-07-14: no mobile o trigger era 1px — o header
               pinava imediatamente ao menor toque de scroll e, como o estado
               sticky é mais BAIXO que o expandido (esconde brand bar/top bar),
               o conteúdo dava um salto visível já no início da rolagem. Em
               coleções (com seções altas acima do grid) isso ficava óbvio; na
               busca (página curta) mal aparecia. Agora só pina depois que o
               header saiu naturalmente da tela — sem salto. Usa a altura
               sticky (menor) como limiar para a transição ser imperceptível. */
            return getHeaderHeight() || 74;
        }

        /* PERF/BUGFIX (2026-06): altura do header agora é cacheada.
           Antes, getHeaderHeight() removia/recolocava a classe sticky
           (2 reflows forçados) A CADA frame de scroll e A CADA resize.
           No pinch-zoom mobile (rajada de resizes) isso travava a página. */
        let cachedHeaderHeight = 0;

        /* by🔥Pista 2026-07-14: mede a altura que o header terá QUANDO FIXO
           (com a classe sticky), não a estática expandida. O spacer precisa
           reservar exatamente a altura do header pinado; medindo a expandida
           (maior), o spacer empurrava o conteúdo além do necessário e, ao
           pinar, tudo "pulava". Força a classe sticky só durante a medição
           (1 reflow, cacheado). Vale mobile e desktop, pois ambos compactam. */
        function measureHeaderHeight() {
            const wasSticky = header.classList.contains('header-is-sticky');

            if (!wasSticky) {
                header.classList.add('header-is-sticky');
            }

            const height = header.offsetHeight;

            if (!wasSticky) {
                header.classList.remove('header-is-sticky');
            }

            cachedHeaderHeight = height;
            return height;
        }

        function getHeaderHeight() {
            return cachedHeaderHeight || measureHeaderHeight();
        }

        function updateSpacerHeight() {
            const height = getHeaderHeight();

            spacer.style.height = height + 'px';

            if (oldSpacer) {
                oldSpacer.style.height = '0px';
                oldSpacer.style.display = 'none';
            }
        }

        function enableSticky() {
            /* Só mexe no DOM na TRANSIÇÃO para sticky, não a cada frame */
            if (header.classList.contains('header-is-sticky') && spacer.classList.contains('is-active')) return;
            updateSpacerHeight();
            spacer.classList.add('is-active');
            header.classList.add('header-is-sticky');
        }

        function disableSticky() {
            header.classList.remove('header-is-sticky');
            spacer.classList.remove('is-active');
            spacer.style.height = '0px';

            if (oldSpacer) {
                oldSpacer.style.height = '0px';
                oldSpacer.style.display = 'none';
            }
        }

        let lastScrollTop = 0;

        function handleStickyHeader() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const triggerPoint = getTriggerPoint();

            if (scrollTop >= triggerPoint) {
                enableSticky();
                // Direção do scroll: adiciona classe para CSS diferenciar comportamento
                if (scrollTop < lastScrollTop) {
                    header.classList.add('scrolling-up');
                    header.classList.remove('scrolling-down');
                } else if (scrollTop > lastScrollTop) {
                    header.classList.add('scrolling-down');
                    header.classList.remove('scrolling-up');
                }
            } else {
                disableSticky();
                header.classList.remove('scrolling-up', 'scrolling-down');
            }
            lastScrollTop = scrollTop;
        }

        let ticking = false;

        function requestStickyUpdate() {
            if (ticking) return;

            ticking = true;

            window.requestAnimationFrame(function () {
                handleStickyHeader();
                ticking = false;
            });
        }

        window.addEventListener('scroll', requestStickyUpdate, { passive: true });

        /* BUGFIX pinch-zoom (2026-06): no mobile, o gesto de pinçar dispara
           rajadas de 'resize' do viewport visual SEM mudar o innerWidth.
           O handler antigo rodava medições síncronas a cada evento e
           congelava a página. Agora: debounce + só reage se a LARGURA
           do layout realmente mudou (rotação, redimensionar janela). */
        let resizeTimer = null;
        let lastLayoutWidth = window.innerWidth;

        window.addEventListener('resize', function () {
            if (resizeTimer) clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                if (window.innerWidth === lastLayoutWidth) return; /* pinch-zoom: ignora */
                lastLayoutWidth = window.innerWidth;
                measureHeaderHeight();
                if (spacer.classList.contains('is-active')) {
                    updateSpacerHeight();
                }
                handleStickyHeader();
            }, 150);
        });

        window.addEventListener('load', function () {
            handleStickyHeader();
        });

        handleStickyHeader();
    }

    const mobileTrigger = document.getElementById('mobile-menu-trigger');
    const mobileDrawer = document.getElementById('mobile-menu-drawer');
    const mobileOverlay = document.getElementById('mobile-menu-overlay');
    const drawerClose = document.getElementById('drawer-close');
    const mobileSearchTrigger = document.getElementById('mobile-search-trigger');
    const mobileSearchBar = document.getElementById('mobile-search-bar');

    if (mobileTrigger && mobileDrawer && mobileOverlay) {
        mobileTrigger.addEventListener('click', () => {
            setDrawerHeightFallback();
            mobileDrawer.classList.add('is-open');
            mobileOverlay.classList.add('is-open');
            lockBodyScroll();
        });
    }

    /* FIX 2026-08-27: fallback em px para navegadores sem suporte a svh
       (Safari iOS < 15.4, ainda relevante no Brasil). window.innerHeight
       já reflete a altura REAL disponível no momento da medição — inclui
       o efeito da toolbar do navegador estar visível ou recolhida. Medido
       só na hora de abrir o drawer (não em todo resize/scroll) para não
       competir com o próprio scroll do body que a trava abaixo controla.
       Em navegadores COM suporte a svh, --drawer-vh também é setada, mas
       a regra CSS já usa 100svh como valor mais específico antes dela —
       na prática, esta variável só entra em uso onde svh não existe. */
    function setDrawerHeightFallback() {
        document.documentElement.style.setProperty('--drawer-vh', window.innerHeight + 'px');
    }

    /* Reage a rotação de tela ou a toolbar do navegador recolher/expandir
       enquanto o drawer já está aberto — sem isso, a altura ficaria presa
       na medição do momento da abertura. */
    window.addEventListener('resize', () => {
        if (mobileDrawer && mobileDrawer.classList.contains('is-open')) {
            setDrawerHeightFallback();
        }
    });

    /* FIX 2026-08-27: trava de scroll do body enquanto o drawer mobile
       está aberto — reforço para overscroll-behavior:contain (CSS, em
       .drawer-scroll-area). O CSS sozinho cobre a maioria dos navegadores,
       mas o Safari iOS mais antigo tem histórico de ignorar
       overscroll-behavior durante o gesto de rubber-band/bounce, deixando
       o scroll "vazar" para a página por trás do overlay — o comportamento
       relatado. position:fixed no body é a técnica que funciona de forma
       confiável em todo o espectro de iOS/Android; salva e restaura o
       scrollY para a página não pular ao fechar o drawer. */
    var lockedScrollY = 0;
    function lockBodyScroll() {
        lockedScrollY = window.scrollY || window.pageYOffset || 0;
        document.body.style.position = 'fixed';
        document.body.style.top = (-lockedScrollY) + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
    }
    function unlockBodyScroll() {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, lockedScrollY);
    }

    function closeDrawer() {
        if (mobileDrawer) {
            mobileDrawer.classList.remove('is-open');
        }

        if (mobileOverlay) {
            mobileOverlay.classList.remove('is-open');
        }

        unlockBodyScroll();
    }

    if (drawerClose) {
        drawerClose.addEventListener('click', closeDrawer);
    }

    if (mobileOverlay) {
        mobileOverlay.addEventListener('click', closeDrawer);
    }

    if (mobileSearchTrigger && mobileSearchBar) {
        mobileSearchTrigger.addEventListener('click', () => {
            mobileSearchBar.classList.toggle('active');

            /* FIX 2026-08-27: aria-expanded também controla, via CSS, qual
               dos dois SVGs do botão aparece (lupa fechado / seta aberto). */
            mobileSearchTrigger.setAttribute('aria-expanded', mobileSearchBar.classList.contains('active') ? 'true' : 'false');

            /* by🔥Pista 2026-07-14: coleção/busca mobile — a barra de busca
               abre em position:absolute logo abaixo do header, exatamente na
               mesma faixa onde o toolbar sticky de filtros (toolbar.js) se
               fixa (top = bottom do header). Avisamos o toolbar para ele se
               reposicionar NA HORA (ele só recalculava no scroll), descendo
               para logo abaixo da busca aberta. A classe no <html> permite
               ajustes de CSS se necessário. */
            document.documentElement.classList.toggle('pista-mobile-search-open', mobileSearchBar.classList.contains('active'));
            /* by🔥Pista 2026-07-14: dispatch em duplo rAF — o dispatch
               síncrono media o header ANTES de o browser refluir a barra de
               busca recém-aberta, então o toolbar não descia e a busca abria
               atrás dele. Dois rAF garantem que o layout assentou. */
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    window.dispatchEvent(new CustomEvent('pista:header-metrics'));
                });
            });

            if (mobileSearchBar.classList.contains('active')) {
                setTimeout(() => {
                    const mobileInput = mobileSearchBar.querySelector('input');

                    if (mobileInput) {
                        mobileInput.focus();
                    }
                }, 100);
            }
        });
    }

    // Mobile accordion: brands block uses button.mobile-acc-header (no URL)
    const accHeaders = document.querySelectorAll('button.mobile-acc-header');
    accHeaders.forEach(header => {
        header.addEventListener('click', function () {
            const item = this.closest('.mobile-acc-item');
            if (item) {
                const isActive = item.classList.toggle('active');
                this.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            }
        });
    });

    // Mobile accordion: category items use .mobile-acc-toggle button inside div.mobile-acc-header
    const accToggles = document.querySelectorAll('.mobile-acc-toggle');
    accToggles.forEach(toggle => {
        toggle.addEventListener('click', function () {
            const item = this.closest('.mobile-acc-item');
            if (item) {
                const isActive = item.classList.toggle('active');
                this.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            }
        });
    });
    
    const promoItems = document.querySelectorAll('.nav-promo-item');

    if (promoItems.length > 1) {
        let pIndex = 0;

        promoItems[0].classList.add('active');

        setInterval(() => {
            promoItems[pIndex].classList.remove('active');
            pIndex = (pIndex + 1) % promoItems.length;
            promoItems[pIndex].classList.add('active');
        }, 3000); 
    } else if (promoItems.length === 1) {
        promoItems[0].classList.add('active');
    }

    const menuItemsWithDelay = document.querySelectorAll('.nav-item-wrapper, .brand-menu-item');

    /* MENU BACKDROP (2026-10-28, by🔥Pista): megamenu e dropdowns da barra
       de marca escurecem a página com o mesmo scrim da busca
       (html.pista-menu-active → CSS). Só itens que têm dropdown ligam o
       scrim; o desligamento espera 150ms para não piscar ao passar de um
       item para o vizinho. */
    let menuBackdropOffTimer;
    const setMenuBackdrop = (isOn) => {
        clearTimeout(menuBackdropOffTimer);
        if (isOn) {
            document.documentElement.classList.add('pista-menu-active');
        } else {
            menuBackdropOffTimer = setTimeout(() => {
                if (!document.querySelector('.nav-item-wrapper.is-hovered, .brand-menu-item.is-hovered')) {
                    document.documentElement.classList.remove('pista-menu-active');
                }
            }, 150);
        }
    };

    menuItemsWithDelay.forEach(item => {
        let hoverTimer;
        const hasDropdown = !!item.querySelector('.megamenu-container, .brand-mini-dropdown');

        item.addEventListener('mouseenter', () => {
            hoverTimer = setTimeout(() => {
                item.classList.add('is-hovered');
                const trigger = item.querySelector('[aria-expanded]');
                if (trigger) trigger.setAttribute('aria-expanded', 'true');
                if (hasDropdown) setMenuBackdrop(true);
            }, 200);
        });

        item.addEventListener('mouseleave', () => {
            clearTimeout(hoverTimer);
            item.classList.remove('is-hovered');
            const trigger = item.querySelector('[aria-expanded]');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
            setMenuBackdrop(false);
        });
    });
});
/* ACCOUNT BACKDROP (2026-10-28, by🔥Pista): o dropdown de conta escurece a
   página com o mesmo scrim da busca (html.pista-account-active → CSS).
   Intenção de hover: abre após 120ms (passar o mouse de raspão não pisca a
   tela) e fecha após 150ms (dá tempo de levar o mouse até o menu).
   Teclado: focusin/focusout no bloco têm o mesmo efeito. */
(function initPistaAccountBackdrop() {
    const run = () => {
        const item = document.querySelector('.pista-action-item--account');
        if (!item) return;

        const trigger = item.querySelector('a[aria-haspopup]');
        let openTimer = null;
        let closeTimer = null;
        let suppressFocusOpen = false;

        const setOpen = (isOpen) => {
            item.classList.toggle('is-open', isOpen);
            document.documentElement.classList.toggle('pista-account-active', isOpen);
            if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        };

        const open = () => {
            clearTimeout(closeTimer);
            if (item.classList.contains('is-open')) return;
            openTimer = setTimeout(() => setOpen(true), 120);
        };

        const close = () => {
            clearTimeout(openTimer);
            closeTimer = setTimeout(() => setOpen(false), 150);
        };

        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', close);
        item.addEventListener('focusin', () => {
            if (suppressFocusOpen) { suppressFocusOpen = false; return; }
            clearTimeout(closeTimer);
            setOpen(true);
        });
        item.addEventListener('focusout', (e) => {
            if (!item.contains(e.relatedTarget)) close();
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && item.classList.contains('is-open')) {
                setOpen(false);
                if (trigger && item.contains(document.activeElement) && document.activeElement !== trigger) {
                    suppressFocusOpen = true;
                    trigger.focus();
                }
            }
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})();

/* CART BADGE (2026-10-28, by🔥Pista): esconde o badge do carrinho do header
   quando a contagem é 0. Vários scripts do tema só trocam o texto de
   [data-cart-count]; o observer acompanha essas trocas. */
(function initPistaCartBadge() {
    const run = () => {
        document.querySelectorAll('.pa-icon-btn .cart-bubble-pista[data-cart-count]').forEach((badge) => {
            const sync = () => {
                const n = parseInt(badge.textContent, 10);
                badge.classList.toggle('is-empty', !(n > 0) && badge.textContent.trim() !== '99+');
            };
            sync();
            new MutationObserver(sync).observe(badge, { childList: true, characterData: true, subtree: true });
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})();